interface EyeIconProps {
    className?: string;
}

export default function EyeIcon({ className = '' }: EyeIconProps) {
    return (
        <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24 36C35.0457 36 44 24 44 24C44 24 35.0457 12 24 12C12.9543 12 4 24 4 24C4 24 12.9543 36 24 36Z" stroke="currentColor" strokeWidth="4" strokeLinejoin="round"/>
            <path d="M24 29C26.7614 29 29 26.7614 29 24C29 21.2386 26.7614 19 24 19C21.2386 19 19 21.2386 19 24C19 26.7614 21.2386 29 24 29Z" stroke="currentColor" strokeWidth="4" strokeLinejoin="round"/>
        </svg>
    );
}
